import React, { useContext, useEffect, useState, useRef, useCallback, useMemo } from "react";
import { Modal, Button, message, Input } from "antd";
import "./index.less";
import querystring from "querystring";
import ChatState from "@/types/chat/State";
import { Employee } from "@/types/chat";
import { useTranslation } from "react-i18next";
import { approveAccountEXP, getApplyAccountEXPReq } from "@/api/ebook";
import { Loading } from "@jd/focus-desktop-comps";
import { getQrCode } from "@/components/Joyspace/api/page";
import GlobalContext, { GlobalContextConfig } from "@/context/GlobalContext";
import { FocusSDK } from "@/utils";
import {
  downLoadFile,
  getHeadImgThumbUrl,
  html2Canvas,
  setManageNoticeTipsTool
} from "@/utils/chat/index";
import { debounce } from "lodash";
import { changeEgovUrl } from "@/utils/tools";
import { connect } from "dvajs";
import dayjs from "dayjs";
import { analysisLog } from "@/utils/logAnalytics";
import { APP_NAME } from "@/config/name";

function AccountDelay(props: {
  visible: boolean;
  onCancel: () => void;
  title: string;
  validDate?: string; // 申请延期入口有两个 1）左上角个人信息、2）ai卡片申请延期按钮  通过有效期传参 validDate ：  来区分ui
  controller?: boolean; // 管理者驳回原因（true），外部账户申请延期(false) 都是在这个页面处理
  messageData?: any; // ai卡片进入带入当前卡片数据
}) {
  const { t } = useTranslation("chat");
  const { t: comT } = useTranslation("common");
  const { visible, onCancel, title, validDate, controller, messageData } = props;
  const [textarea, setTextarea] = useState<string>("");
  const [showDelayReason, setShowDelayReason] = useState<boolean>(false);
  // const { app: appId, teamId, name, nickName, avatar: headImg } = currentEmployee || {};
  const applyDelay = useCallback(() => {
    setShowDelayReason(true);
  }, []);

  const confirmEditIntro = useCallback(async () => {
    if (!textarea) return message.warning("请输入申请原因");
    const [result, error] = await getApplyAccountEXPReq({ applyReason: textarea });
    if (error) {
      message.error(error);
      return;
    }
    analysisLog("xtbg_add_home_1637657110163", "72");
    message.success("操作成功");
    onCancel();
  }, [onCancel, textarea]);

  const controllerConfirmEditIntro = useCallback(async () => {
    if (!textarea) return message.warning("请输入驳回原因");
    const [result, error] = await approveAccountEXP({
      recordId: messageData?.extend?.recordId, // AI卡片里审核在extend中, 消息通知列表里参见返回的字段
      result: 0, // 0:驳回, 1:通过
      apprOption: textarea
    });
    if (error) {
      message.error(error);
      return;
    }
    const { status } = result;
    setManageNoticeTipsTool(status);
    onCancel();
  }, [messageData, onCancel, textarea]);

  const modalFooterView = (
    <div>
      <Button onClick={onCancel} className="cancelBtn">
        {t("cancelText")}
      </Button>

      <Button type="primary" onClick={controller ? controllerConfirmEditIntro : confirmEditIntro}>
        {t("determine")}
      </Button>
    </div>
  );

  return (
    <Modal
      visible={visible}
      title={title}
      width={580}
      okText="确定"
      cancelText="取消"
      onCancel={onCancel}
      footer={(!validDate || showDelayReason) && modalFooterView}
      bodyStyle={{
        padding: "24px 24px 10px"
      }}
    >
      <div className="delay-wrap">
        {validDate && (
          <>
            <p>
              账号有效期至
              <span>{dayjs(validDate).format("YYYY年M月D日")}</span>
            </p>
            <p>账号有效期为6个月，超期后您将不能正常使用{APP_NAME}。 如需继续使用，可申请延期。</p>
            {!showDelayReason && (
              <>
                <p>
                  <Button
                    type="primary"
                    onClick={() => {
                      applyDelay();
                    }}
                    clstag="pageclick|keycount|xtbg_add_home_1637657110163|56"
                  >
                    申请延期
                  </Button>
                </p>
                <p>
                  <Button
                    type="link"
                    onClick={onCancel}
                    clstag="pageclick|keycount|xtbg_add_home_1637657110163|74"
                  >
                    暂不延期
                  </Button>
                </p>
              </>
            )}
          </>
        )}

        {(!validDate || showDelayReason) && (
          <>
            <Input.TextArea
              placeholder={controller ? "请填写驳回原因" : "请填写延期申请原因"}
              rows={4}
              onChange={(e) => setTextarea(e.target.value.trim())}
              maxLength={100}
            />
            <p className="refusal-cause-length">
              <span>{textarea.length || 0}</span>
              /100
            </p>
          </>
        )}
      </div>
    </Modal>
  );
}
export default connect(
  ({ chat }: { chat: ChatState }) => {
    return {
      // currentEmployee: chat?.currentEmployee ? chat?.currentEmployee : {},
    };
  },
  (dispatch: any) => ({})
)(AccountDelay);
